// Pandectes: footer link "#reopenBanner" opens the consent dialog, floating widget stays hidden.
// The app's own custom trigger is a Premium feature, so the link clicks the hidden widget instead.
(() => {
  const getRoot = () => document.querySelector('pandectes-cmp')?.shadowRoot;

  const hideWidget = () => {
    const root = getRoot();
    if (!root) return false;
    if (!root.getElementById('custom-hide-widget')) {
      const style = document.createElement('style');
      style.id = 'custom-hide-widget';
      style.textContent = '.widget { display: none !important; }';
      root.appendChild(style);
    }
    return true;
  };

  if (!hideWidget()) {
    const observer = new MutationObserver(() => hideWidget() && observer.disconnect());
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest('a[href*="#reopenBanner" i]');
      if (!link) return;
      event.preventDefault();
      event.stopPropagation();
      // Open after the click has finished, otherwise Pandectes treats it as a click outside and closes again.
      setTimeout(() => getRoot()?.querySelector('button.widget')?.click());
    },
    true
  );
})();
